import localFont from 'next/font/local'

export const publicSans = localFont({
    src: [
        {
            path: '../fonts/GoogleSansFlex-Regular.woff2',
            weight: '400',
            style: 'normal',
        },
        {
            path: '../fonts/GoogleSansFlex-Semibold.woff2',
            weight: '600',
            style: 'normal',
        },
        {
            path: '../fonts/GoogleSansFlex-Bold.woff2',
            weight: '700',
            style: 'normal',
        },
    ],
    variable: '--font-public-sans',
    display: 'swap',
    preload: false,
    fallback: ['system-ui', 'sans-serif'],
})

/** The public site's typeface on a surface outside its page root, such as a dialog portaled to the overlay root. */
export const publicFontClassName = `${publicSans.variable} font-[family-name:var(--font-public-sans)]`
